var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 36,
    viewBox: "0 0 35 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_368_1514)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.5441 0.55957C7.95211 0.55957 0.148315 8.40175 0.148315 18.0409C0.148315 27.6794 7.95211 35.5223 17.5441 35.5223C27.1354 35.5223 34.9399 27.6794 34.9399 18.0409C34.9399 8.40175 27.1368 0.55957 17.5441 0.55957ZM21.8703 18.6564H19.0401V28.7934H14.8464C14.8464 28.7934 14.8464 23.2545 14.8464 18.6564H12.8529V15.0736H14.8464V12.7562C14.8464 11.0965 15.6312 8.50315 19.0787 8.50315L22.1863 8.51512V11.9929C22.1863 11.9929 20.2979 11.9929 19.9307 11.9929C19.5636 11.9929 19.0415 12.1774 19.0415 12.9689V15.0743H22.2368L21.8703 18.6564Z",
    fill: "#2E1A47"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_368_1514"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.7916,
    height: 34.9627,
    fill: "white",
    transform: "translate(0.148315 0.55957)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.bb83a8d38c8d7fae3e8c9c8e26bb9aaf.svg";
export { ForwardRef as ReactComponent };